// Price formatting utilities. All products carry prix_ht and prix_ttc.
const nf = new Intl.NumberFormat("fr-FR");

export function fmtNumber(n) {
  if (n == null || isNaN(n)) return "—";
  return nf.format(Math.round(n));
}

export function getHT(item) {
  if (item == null) return null;
  if (item.prix_ht != null) return item.prix_ht;
  if (item.prix_ttc != null) return Math.round(item.prix_ttc / 1.2);
  if (item.prix_a_partir != null) {
    return item.prix_unite === "TTC" ? Math.round(item.prix_a_partir / 1.2) : item.prix_a_partir;
  }
  return null;
}

export function getTTC(item) {
  if (item == null) return null;
  if (item.prix_ttc != null) return item.prix_ttc;
  if (item.prix_ht != null) return Math.round(item.prix_ht * 1.2);
  if (item.prix_a_partir != null) {
    return item.prix_unite === "TTC" ? item.prix_a_partir : Math.round(item.prix_a_partir * 1.2);
  }
  return null;
}

export function fmtPriceHT(item) {
  const v = getHT(item);
  return v == null ? "—" : `${nf.format(v)} € HT`;
}

export function fmtPriceTTC(item) {
  const v = getTTC(item);
  return v == null ? "—" : `${nf.format(v)} € TTC`;
}

export function fmtBoth(item) {
  const ht = getHT(item);
  const ttc = getTTC(item);
  if (ht == null && ttc == null) return "—";
  return `${ht != null ? nf.format(ht) + " € HT" : ""}${ht != null && ttc != null ? " / " : ""}${ttc != null ? nf.format(ttc) + " € TTC" : ""}`;
}
